import { lazy } from "react";

const routes = [
  {
    path: "/trava-knight",
    exact: true,
    component: lazy(() => import("src/pages/TravaKnight")),
    animation: "fadeIn",
  },
  {
    path: "/trava-armoury",
    exact: true,
    component: lazy(() => import("src/pages/TravaArmoury")),
    animation: "fadeIn",
  },
  {
    path: "/farming",
    exact: true,
    component: lazy(() => import("src/pages/Farming")),
    animation: "fadeIn",
  },
  {
    path: "/statistic",
    exact: true,
    component: lazy(() => import("src/pages/Statistic")),
    animation: "fadeIn",
  },
  {
    path: "/profile",
    exact: true,
    component: lazy(() => import("src/pages/Profile")),
    animation: "fadeIn",
  },
  {
    path: "/profile/sign",
    exact: true,
    component: lazy(() => import("src/pages/Profile/SignMessage")),
    animation: "fadeIn",
  },
];

export default routes;
